import React, { CSSProperties } from 'react';

type Props = {
  style?: CSSProperties;
  fill?: string;
  width?: string | number;
  className?: string;
  viewBox?: string;
};

const SVG: React.FC<Props> = ({
  style = {},
  fill = '#000',
  width = '100%',
  className = '',
  viewBox = '0 0 94 124',
}) => (
  <svg
    width={width}
    style={style}
    height={width}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ''}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g id="Grupo_2652" data-name="Grupo 2652" transform="translate(0 0)">
      <g
        id="Grupo_2650"
        data-name="Grupo 2650"
        transform="translate(21.646 19.008)"
      >
        <path
          fill={fill}
          id="Caminho_4421"
          data-name="Caminho 4421"
          d="M397.15,327.3c-7.963,0-13.722-10.6-13.722-17.733a13.736,13.736,0,1,1,27.473,0C410.9,316.7,405.144,327.3,397.15,327.3Zm0-27.932a10.178,10.178,0,0,0-10.169,10.2c0,6.044,5.042,14.18,10.169,14.18,5.157,0,10.2-8.136,10.2-14.18A10.184,10.184,0,0,0,397.15,299.368Z"
          transform="translate(-371.741 -295.816)"
        />
        <path
          fill={fill}
          id="Caminho_4422"
          data-name="Caminho 4422"
          d="M422.983,342.741a1.762,1.762,0,1,1,0-3.524,7.353,7.353,0,0,0,7.334-7.361V314.638a14.186,14.186,0,0,0-13.35-14.151l-7.133,9.081a1.82,1.82,0,0,1-2.779,0l-7.161-9.081a14.183,14.183,0,0,0-13.321,14.151v17.218a7.354,7.354,0,0,0,7.334,7.361,1.762,1.762,0,1,1,0,3.524,10.881,10.881,0,0,1-10.886-10.886V314.638a17.764,17.764,0,0,1,17.732-17.732,1.809,1.809,0,0,1,1.4.688l6.273,7.993,6.3-7.993a1.811,1.811,0,0,1,1.4-.687,17.764,17.764,0,0,1,17.732,17.732v17.218A10.881,10.881,0,0,1,422.983,342.741Z"
          transform="translate(-383.021 -265.68)"
        />
        <path
          fill={fill}
          id="Caminho_4423"
          data-name="Caminho 4423"
          d="M385.115,353.78a1.761,1.761,0,0,1-1.776-1.747V299.294a1.776,1.776,0,0,1,3.553,0v52.739A1.761,1.761,0,0,1,385.115,353.78Z"
          transform="translate(-374.229 -248.789)"
        />
        <path
          fill={fill}
          id="Caminho_4424"
          data-name="Caminho 4424"
          d="M386.129,353.78a1.76,1.76,0,0,1-1.775-1.747V299.294a1.776,1.776,0,1,1,3.552,0v52.739A1.76,1.76,0,0,1,386.129,353.78Z"
          transform="translate(-346.167 -248.789)"
        />
        <path
          fill={fill}
          id="Caminho_4425"
          data-name="Caminho 4425"
          d="M385.594,325.994a1.736,1.736,0,0,1-1.747-1.747V300.3a1.762,1.762,0,1,1,3.523,0v23.949A1.743,1.743,0,0,1,385.594,325.994Z"
          transform="translate(-360.184 -221.003)"
        />
      </g>
      <g id="Grupo_2651" data-name="Grupo 2651" transform="translate(54.811)">
        <path
          fill={fill}
          id="Caminho_4426"
          data-name="Caminho 4426"
          d="M397.933,326.618c-7.964,0-13.75-10.6-13.75-17.733a13.75,13.75,0,0,1,27.5,0C411.684,316.019,405.9,326.618,397.933,326.618Zm0-27.932a10.221,10.221,0,0,0-10.2,10.2c0,6.073,5.042,14.18,10.2,14.18s10.2-8.106,10.2-14.18A10.221,10.221,0,0,0,397.933,298.687Z"
          transform="translate(-384.183 -295.135)"
        />
        <path
          fill={fill}
          id="Caminho_4427"
          data-name="Caminho 4427"
          d="M400.9,342.061a1.776,1.776,0,1,1,0-3.552,7.355,7.355,0,0,0,7.362-7.334V313.958a14.255,14.255,0,0,0-13.35-14.181l-7.134,9.081a1.776,1.776,0,1,1-2.807-2.177l7.705-9.8a1.783,1.783,0,0,1,1.4-.658,17.745,17.745,0,0,1,17.732,17.732v17.217A10.924,10.924,0,0,1,400.9,342.061Z"
          transform="translate(-372.626 -264.971)"
        />
        <path
          fill={fill}
          id="Caminho_4428"
          data-name="Caminho 4428"
          d="M386.884,353.1a1.785,1.785,0,0,1-1.776-1.775V298.585a1.762,1.762,0,0,1,1.776-1.748,1.743,1.743,0,0,1,1.775,1.748v52.739A1.766,1.766,0,0,1,386.884,353.1Z"
          transform="translate(-358.609 -248.08)"
        />
      </g>
      <g id="Grupo_2653" data-name="Grupo 2653">
        <path
          fill={fill}
          id="Caminho_4426-2"
          data-name="Caminho 4426"
          d="M397.933,326.618c7.964,0,13.75-10.6,13.75-17.733a13.75,13.75,0,0,0-27.5,0C384.183,316.019,389.97,326.618,397.933,326.618Zm0-27.932a10.221,10.221,0,0,1,10.2,10.2c0,6.073-5.042,14.18-10.2,14.18s-10.2-8.106-10.2-14.18A10.221,10.221,0,0,1,397.933,298.687Z"
          transform="translate(-372.495 -295.135)"
        />
        <path
          fill={fill}
          id="Caminho_4427-2"
          data-name="Caminho 4427"
          d="M395.514,342.061a1.776,1.776,0,1,0,0-3.552,7.355,7.355,0,0,1-7.362-7.334V313.958A14.255,14.255,0,0,1,401.5,299.777l7.134,9.081a1.776,1.776,0,1,0,2.807-2.177l-7.705-9.8a1.783,1.783,0,0,0-1.4-.658A17.745,17.745,0,0,0,384.6,313.958v17.217A10.923,10.923,0,0,0,395.514,342.061Z"
          transform="translate(-384.6 -264.971)"
        />
        <path
          fill={fill}
          id="Caminho_4428-2"
          data-name="Caminho 4428"
          d="M386.883,353.1a1.785,1.785,0,0,0,1.776-1.775V298.585a1.762,1.762,0,0,0-1.776-1.748,1.743,1.743,0,0,0-1.775,1.748v52.739A1.766,1.766,0,0,0,386.883,353.1Z"
          transform="translate(-375.969 -248.08)"
        />
      </g>
    </g>
  </svg>
);

export default SVG;
